import { useDebounce as a } from "@partoohub/hooks";
import { useInfiniteQuery as i } from "react-query";
import { useBusinessModalContext as c } from "../BusinessModalContext.js";
import { useOrgsQueryParams as g } from "./queryParams/organization/useOrgsQueryParams.js";
const u = "orgs", O = () => {
  const {
    apiClient: s
  } = c(), t = g(), o = a(t, 300), r = i([u, o], ({
    pageParam: e = 1
  }) => s.organization.searchOrgs({
    page: e,
    ...o
  }), {
    getNextPageParam: (e) => e.page < e.max_page ? e.page + 1 : void 0,
    refetchOnReconnect: !1,
    refetchOnWindowFocus: !1
  }), n = r?.data?.pages?.flatMap((e) => e.orgs) ?? [];
  return {
    query: r,
    organizations: n
  };
};
export {
  u as ORGS,
  O as useOrganizations
};
